import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';
import { toCamelCase } from '../config/utils';

const getDefaultState = () => toCamelCase(window.wall.customImage || {});

// src: null,
// widthIn: null,
// heightIn: null,
// posX: null,
// poxY: null

const customImage = createReducer(getDefaultState(), {
  [Constants.customImage.update]: (state, { src }) => ({
    ...state,
    src
  }),
  [Constants.customImage.add]: (state, {
    src,
    widthIn,
    heightIn,
    posX,
    posY
  }) => ({
    src,
    widthIn,
    heightIn,
    posX,
    posY
  }),
  [Constants.customImage.remove]: () => ({}),
  [Constants.customImage.move]: (state, { posX, posY }) => ({
    ...state,
    posX,
    posY
  })
});

export default customImage;
